import { render, staticRenderFns } from "./categoria_servico.vue?vue&type=template&id=c3f38786&scoped=true&"
import script from "./categoria_servico.vue?vue&type=script&lang=js&"
export * from "./categoria_servico.vue?vue&type=script&lang=js&"
import style0 from "./categoria_servico.vue?vue&type=style&index=0&id=c3f38786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f38786",
  null
  
)

export default component.exports